import { Injectable } from '@angular/core';
import * as firebase from "firebase";
import * as firebaseui from 'firebaseui'
import { environment } from '../../../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private ui!: firebaseui.auth.AuthUI;

  constructor() { 
    try{
      firebase.initializeApp(environment.firebaseConfig);
    }
    catch(e){
      //If firebase is already initialized than do nothing
    }
    this.ui = new firebaseui.auth.AuthUI(firebase.auth());
  }

  getFirebaseuiInstance(){
    return this.ui;
  }
}
